export const STATO_PREVENTIVO_FIRMATO = "preventivo firmato";

const attese = new Map();
const presenti = new Map();
const ascoltatori = new Set();

function normalizza(valore) {
  return String(valore ?? "").trim().toLowerCase();
}

export function isPreventivoFirmato(stato) {
  if (!stato) {
    return false;
  }
  if (typeof stato === "string") {
    return normalizza(stato) === STATO_PREVENTIVO_FIRMATO;
  }
  return normalizza(stato.stato) === STATO_PREVENTIVO_FIRMATO;
}

export function idPreventivoFirmato(stati) {
  const riga = (stati || []).find((stato) => isPreventivoFirmato(stato));
  return riga ? Number(riga.id) : null;
}

export function ordinaStati(stati) {
  const lista = [...(stati || [])];
  const indiceFirmato = lista.findIndex((stato) => isPreventivoFirmato(stato));
  const indicePreventivo = lista.findIndex(
    (stato) => normalizza(stato?.stato) === "preventivo"
  );
  if (indiceFirmato === -1 || indicePreventivo === -1) {
    return lista;
  }
  const [firmato] = lista.splice(indiceFirmato, 1);
  const nuovoPreventivo = lista.findIndex(
    (stato) => normalizza(stato?.stato) === "preventivo"
  );
  lista.splice(nuovoPreventivo + 1, 0, firmato);
  return lista;
}

export function vedeSoloPreventivo(user) {
  const area = normalizza(user?.profile?.name);
  return area === "assistenza_clienti" || area === "backoffice";
}

export function statiBasePreventivo(stati) {
  return ordinaStati(stati).filter((stato) => {
    const nome = normalizza(stato?.stato);
    return nome === "preventivo" || nome === STATO_PREVENTIVO_FIRMATO;
  });
}

export function annidaPreventivoFirmato(stati) {
  const lista = (stati || []).map((stato) => ({ ...stato }));
  const indiceFirmato = lista.findIndex((stato) => isPreventivoFirmato(stato));
  if (indiceFirmato === -1) {
    return lista;
  }
  const [firmato] = lista.splice(indiceFirmato, 1);
  const indicePreventivo = lista.findIndex(
    (stato) => normalizza(stato?.stato) === "preventivo"
  );
  if (indicePreventivo === -1) {
    lista.splice(indiceFirmato, 0, firmato);
    return lista;
  }
  lista[indicePreventivo] = {
    ...lista[indicePreventivo],
    sottostati: [firmato],
  };
  return lista;
}

export function timelineFromStati(stati) {
  return annidaPreventivoFirmato(
    ordinaStati(stati).map((stato) => ({
      stato: stato.stato,
      id: stato.id,
      numero: Number(stato.id),
      colore: "default",
      file: null,
    }))
  );
}

export function statoTimelineRaggiunto(statoId, statoCorrente, firmatoId) {
  const id = Number(statoId);
  const corrente = Number(statoCorrente);
  const firmato = Number(firmatoId);
  if (firmato && id === firmato) {
    return corrente === firmato;
  }
  if (firmato && corrente === firmato) {
    return id >= 1 && id <= 5;
  }
  return id <= corrente;
}

export function statoTimelineSuperato(statoId, statoCorrente, firmatoId) {
  const id = Number(statoId);
  const corrente = Number(statoCorrente);
  const firmato = Number(firmatoId);
  if (firmato && id === firmato) {
    return false;
  }
  if (firmato && corrente === firmato) {
    return id >= 1 && id <= 5;
  }
  return id < corrente;
}

export function onPreventivoFirmatoCaricato(callback) {
  ascoltatori.add(callback);
  return () => ascoltatori.delete(callback);
}

export function notificaPreventivoFirmato(typeFile, id) {
  const chiave = String(typeFile);
  if (!presenti.has(chiave)) {
    presenti.set(chiave, new Set());
  }
  presenti.get(chiave).add(Number(id));
  ascoltatori.forEach((callback) => callback(chiave, Number(id)));
}

export async function caricaIdPreventiviFirmati(service, typeFile) {
  const chiave = String(typeFile);
  if (presenti.has(chiave)) {
    return presenti.get(chiave);
  }
  if (!attese.has(chiave)) {
    attese.set(
      chiave,
      service
        .elencoPreventiviFirmati(chiave)
        .then((ids) => {
          const insieme = new Set((ids || []).map((id) => Number(id)));
          presenti.set(chiave, insieme);
          attese.delete(chiave);
          return insieme;
        })
        .catch((error) => {
          attese.delete(chiave);
          throw error;
        })
    );
  }
  return attese.get(chiave);
}

export async function preparaPreventivoFirmato({
  service,
  row,
  typeFile,
  toast,
  lista,
}) {
  if (!isPreventivoFirmato(row?.selectedStato)) {
    return true;
  }
  const files = Array.isArray(row?.filePreventivoFirmato)
    ? row.filePreventivoFirmato.filter(Boolean)
    : row?.filePreventivoFirmato
      ? [row.filePreventivoFirmato]
      : [];
  if (!files.length) {
    toast?.add?.({
      severity: "error",
      summary: "File obbligatorio",
      detail:
        "Per lo stato preventivo firmato devi caricare il preventivo firmato.",
      life: 4000,
    });
    return false;
  }

  await service.uploadPreventivoFirmato({
    files,
    id: row.id,
    type_file: typeFile,
  });

  row.preventivo_firmato = true;
  row.filePreventivoFirmato = null;
  notificaPreventivoFirmato(typeFile, row.id);

  if (Array.isArray(lista)) {
    const rigaLista = lista.find((item) => Number(item.id) === Number(row.id));
    if (rigaLista) {
      rigaLista.preventivo_firmato = true;
    }
  }

  return true;
}
